import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { WHY_BUY } from '../data/seoContent';

export const WhyBuySection = () => (
  <section className="py-16 md:py-20" style={{ background: '#0E3D95' }} data-testid="why-buy-section">
    <div className="max-w-6xl mx-auto px-4">
      <p className="text-sm font-semibold uppercase tracking-wider text-[#F88200] mb-2">Why Leisure Wellness Naples</p>
      <h2 className="font-['Barlow_Condensed'] text-3xl md:text-5xl font-bold uppercase text-white mb-10">Why Buy From Us</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {WHY_BUY.map((w, i) => (
          <div key={w.title} className="bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors" data-testid={`why-buy-item-${i}`}>
            <CheckCircle2 className="text-[#F88200] mb-3" />
            <h3 className="font-bold text-white text-lg mb-1">{w.title}</h3>
            <p className="text-white/75 text-sm md:text-base">{w.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyBuySection;
